import React, { memo } from 'react'
import Flyout from '../Flyout'

import Menu from './Menu'
import * as Styled from './styled'
import { IFlyoutMenuProps } from './types'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import SlideUp from '../SlideUp'
import { useEventListener } from 'hooks'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import BackIcon from 'assets/svgr-icons/ArrowLeft.svg'

const ActionsFlyout: React.FC<IFlyoutMenuProps> = ({
  isOpen,
  anchorEl,
  onClose,
  actions,
  flyoutClassName,
  flyoutOptions,
  isMobileWithDrawer,
  showMobileBackButton = false,
  scrollableElementRef
}) => {
  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  useEventListener('scroll', onClose, scrollableElementRef?.current)

  if (isTablet && isMobileWithDrawer) {
    return (
      <SlideUp isOpen={isOpen} onClose={onClose}>
        {showMobileBackButton && (
          <Styled.SlideUpHeader>
            <Styled.BackButton onClick={onClose}>
              <BackIcon />
              {translate(T.BACK)}
            </Styled.BackButton>
          </Styled.SlideUpHeader>
        )}
        <Menu
          actions={actions}
          onClose={onClose}
          isMobileDrawerStyle={isMobileWithDrawer}
        />
      </SlideUp>
    )
  }
  return (
    <Flyout
      isOpen={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      className={flyoutClassName}
      options={flyoutOptions}
    >
      <Menu actions={actions} onClose={onClose} />
    </Flyout>
  )
}

export default memo(ActionsFlyout)
